import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { UserDataService } from 'src/app/features/user-data.service';
import { MailCenterService } from 'src/app/mail-center/mail-center.service';
import { first } from 'rxjs/operators';
@Component({
  selector: 'app-edit-country',
  templateUrl: './edit-country.component.html',
  styleUrls: ['./edit-country.component.css']
})
export class EditCountryComponent implements OnInit {
  status:string=""; //deciding the shown material
  statusList:any;//list of the status records
  keyCode:any;
  inventionDetailData!:any;
  companyData:any; inventorData:any; attorneyData:any;rdCenter:any;project:any;
  visible=false;
  visibleSummary=false;
  visibleDocuments=false;
  visibleTimeLimits=false;
  visibleDecision=false;
  visibleRecord=false;
  visiblePatents=false;
  value="";
  docType="";
  idNumber=0;
  inventionName:any;
  documentNumber:any;
  inventionDate:any;
  path="";
  priorityCountry="Ülke Seçilmedi";
  inventionType="";
  valid=false;
  fileName="";
  errorCode="";
  error=true;
  errorText:string=""
  docLink:any=[];
  notes:any;
  patentInfo:any=[];
  toggle=false;
  priorityInvention={type:"xxx",country:"yyy",number:""};
  otherForm=false;
  firebaseStorageLink:string="https://firebasestorage.googleapis.com/v0/b/patent-book.appspot.com/o/";
  firebaseStorageLink2:string="?alt=media&token=6c29c21e-dde6-4d0e-8f31-f163afbfdfa8";
  //firebaseStorageLink2:string="?alt=media&token=6c29c21e-dde6-4d0e-8f31-f163afbfdfa8"; Old
  //firebaseStorageLink:string="https://firebasestorage.googleapis.com/v0/b/sisecam-a8421.appspot.com/o/"; Old
  loggedUser="";
  //Invention Data
  priorityName="";
  priorityNumber="";

  visibleCountryList=false;
  visiblePriorty=false;
  visibleEntrence=false;
  firstClaim="";
  countryNote="Ülkesel Not";
  abstract="";
  info="";
  countryStatus:any=[];
  isRecorded=false;
  isPatentExists=false;
  priorityExists=false;
 patentCountry:any;
 patentPriority:any;
 patentType:any;
 patentType2:any;
 patentName:any;
 patentNumber:any;

 patentDate:any;
 abstact:any;
 patentStatus:any;

  constructor(private userData:UserDataService, private auth:AuthService,  private route:Router, private af:AngularFireStorage,private mailService:MailCenterService,private activatedRoute:ActivatedRoute) { }


   ngOnInit(): void {
    this.loggedUser=this.auth.userMail;
    this.idNumber=this.userData.number;
    console.log(this.idNumber);
  //  this.token=this.auth.token;
  }

  ngAfterContentInit(){
    this.keyCode=this.userData.key;
    this.visiblePatents=true;
    this.userData.inventionDetail(this.keyCode).
    subscribe(res=>
      {//console.log(res);
      this.inventionDetailData=res;
      this.companyData=this.inventionDetailData[0].hasOwnProperty('CompanyData') ? this.companyData= this.inventionDetailData[0].CompanyData : this.companyData=[];
      //
      this.attorneyData=this.inventionDetailData[0].hasOwnProperty('AttorneyData') ? this.attorneyData= this.inventionDetailData[0].AttorneyData : this.attorneyData=[];
      this.inventorData=this.inventionDetailData[0].hasOwnProperty('inventorData') ? this.inventorData= this.inventionDetailData[0].inventorData : this.inventorData=[];
      this.project=this.inventionDetailData[0].project;
      this.rdCenter=this.inventionDetailData[0].rdCenter;
      this.status=this.inventionDetailData[0].status.slice(-1)[0].status;
      this.statusList=this.inventionDetailData[0].status;
      this.inventionName=this.inventionDetailData[0].inventionName;
      this.documentNumber=this.inventionDetailData[0].documentNumber;
      this.inventionDate=this.inventionDetailData[0].inventionDate;
      this.docLink=this.inventionDetailData[0].hasOwnProperty('docLink') ? this.docLink= this.inventionDetailData[0].docLink : this.docLink=[];
      this.notes=this.inventionDetailData[0].hasOwnProperty('notes') ? this.notes= this.inventionDetailData[0].notes : this.notes="not yok";
      this.visible=true;
      this.patentInfo=this.inventionDetailData[0].hasOwnProperty('patentInfo') ? this.patentInfo= this.inventionDetailData[0].patentInfo : this.patentInfo=[];
      this.patentCountry=this.patentInfo[this.idNumber].patentCountry;

      this.patentPriority=this.patentInfo[this.idNumber].patentType;
     this.patentType=this.patentInfo[this.idNumber].patentType;
     this.patentType2=this.patentInfo[this.idNumber].patentType;
      this.patentName=this.patentInfo[this.idNumber].patentName;
      this.patentNumber=this.patentInfo[this.idNumber].patentNumber;

      this.patentDate=this.patentInfo[this.idNumber].patentDate;
      this.abstract=this.patentInfo[this.idNumber].abstract;
      this.firstClaim=this.patentInfo[this.idNumber].firstClaim;
      this.countryNote=this.patentInfo[this.idNumber].countryNote;
      this.patentStatus=this.patentInfo[this.idNumber].patentStatus.slice(-1)[0].status;
      console.log(this.patentStatus,this.patentType,this.patentType2)
      this.patentStatus.length > 2 ? this.patentStatus:this.patentStatus=this.patentStatus[0];
      this.patentInfo[this.idNumber].priority.includes("Rüç") ? this.priorityInvention={type:"",country:"",number:""}:this.priorityInvention=this.patentInfo[this.idNumber].priority;
      console.log(this.patentStatus,this.patentType)
      this.inventionDetailData[0].hasOwnProperty('patentInfo') ? this.isPatentExists=true : this.isPatentExists=false;
console.log(this.patentInfo);

      })
      }
      showCountries() {this.visibleCountryList=!this.visibleCountryList}
      openPriority() {this.visiblePriorty=true;
                      this.visibleEntrence=false}
      openEnterance(){this.visiblePriorty=false;
                      this.visibleEntrence=true}
      navigate(){this.route.navigate(["patentList/",this.inventionDetailData[0].documentNumber])}

      updateInvention() {

        //console.log(this.patentInfo)
       // this.patentInfo=[];
       this.patentInfo.splice(this.idNumber,1);
       this.countryStatus.push({ status:[this.patentStatus,this.patentDate,this.patentNumber], date: Date.now(), recordigUser:this.loggedUser});
        this.patentInfo.push({patentDate:this.patentDate,
                          patentName:this.patentName,
                          patentNumber: this.patentNumber,

                          patentCountry: this.patentCountry,
                          patentType: this.patentType,
                          patentStatus: this.countryStatus,
                          firstClaim: this.firstClaim,
                          countryNote: this.countryNote,
                          abstract:this.abstract,
                          priority:this.priorityInvention
                          });
        this.visiblePriorty=false;
        this.userData.updateInvention(this.companyData,this.attorneyData,this.rdCenter,this.project,
          this.documentNumber,
          this.inventionName,
          this.inventionDate,
          this.inventorData,
          this.statusList,
          this.docLink,
          this.patentInfo,
          this.keyCode,
          this.notes
          ).
          subscribe(arr=>{
            this.userData.deletionRecords([this.loggedUser,Date.now()],'Ülke Bilgileri Güncellendi', `Dosyanın güncellendiği buluş/ülke : ${this.inventionName}/${this.patentCountry} `).subscribe();
            //Buluş için ilk patent kaydında 1 yıllık ülke ekleme süresi için hatırlatma yapılacak. PCt için mail atılacak
            if (this.patentInfo.length >1) {console.log(this.patentInfo.length);}
            else {console.log("tek buluş")
            const time=(Math.round(Date.now()/1000));
            const date = new Date(this.patentDate);
            const unixTimestamp = Math.floor(date.getTime() / 1000);
            const reminder= [unixTimestamp, unixTimestamp+172800,unixTimestamp+26280000,unixTimestamp+28908000, ]  // Buluş tarihinden 10 ve 11 ay sonra
            const PCTReminder=[unixTimestamp,unixTimestamp+172800, unixTimestamp+70956000,unixTimestamp+73584000, ] //PCT için 27 ve 28.ay hatılatması
            this.mailService.countryDecisionReminder(this.patentDate,this.inventionName, this.patentStatus, reminder).pipe(first())
            .subscribe((resp: any) => {
            console.log({ resp });

            alert("Ülke girişinin yapılması için 10.ay ve 11. ayda hatırlatma yapılacaktır")
            }, (err: any) => {
            console.error({ err });});

            this.mailService.PCTReminder(this.patentDate,this.inventionName, this.patentStatus, PCTReminder).pipe(first())
            .subscribe((resp: any) => {
            console.log({ resp });

            alert("PCT girişi için 27. ve 28. ayda hatılatmalar iletilecektir.")
            }, (err: any) => {
            console.error({ err });});
            }
          //console.log(arr);
          this.isRecorded=true;
        alert("Patent Güncellendi");
        this.route.navigate(['../'], { relativeTo: this.activatedRoute });},
          err=>{
          this.info=err.statusText;
          console.log(this.info);
          alert("Patent Güncellenemedi")});

      }

    }
